import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'epay-register',
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {
  pagetitle = 'New Account Registration'
  constructor(private router: Router) { }

  ngOnInit() {
  }
}
